module.exports = __webpack_public_path__ + "static/media/30OIOS12.1ba476e3.jpg";